<template>
  <v-container class="py-6">
    <v-row>
      <v-col cols="12">
        <v-card elevation="2">
          <v-card-title class="d-flex align-center justify-space-between">
            <div class="d-flex align-center">
              <v-icon color="primary" start>mdi-flash</v-icon>
              Suite Analítica · Reportes y Tiempo Real
            </div>
            <v-chip size="x-small" :color="isConnected ? 'success' : 'error'" variant="flat">
              {{ isConnected ? 'Conectado' : 'Desconectado' }}
            </v-chip>
          </v-card-title>
          <v-card-text>
            <div class="text-caption text-medium-emphasis mb-2">
              Incluye 6.1 (analítica en vivo), 6.2 (métricas por administración), 6.3 (reportes ejecutivos) y 6.4 (KPIs en tiempo real con umbrales y alertas).
            </div>
            <RealtimeAnalyticsWidget />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <!-- Reusa la vista que integra Reportes Ejecutivos + Panel Realtime (6.3 + 6.4) -->
        <RealtimeReports />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRealtimeStore } from '@/stores/realtime'
import RealtimeAnalyticsWidget from '@/components/analytics/RealtimeAnalyticsWidget.vue'
import RealtimeReports from '@/views/reports/RealtimeReports.vue'

const realtime = useRealtimeStore()
const isConnected = computed(() => realtime.isConnected)
</script>

<style scoped>
</style>
